import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LoadingButton } from '@mui/lab';
import { billingServices } from 'src/services/reservation/billing/billing.service'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap';

export const GenerateJournalEntryModal = ({
  openModal,
  setOpenModal,
  selectedItem,
  onComplete
}) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [loadingJournalEntry, setLoadingJournalEntry] = useState(false)
  const [form, setForm] = useState({ billable_exchange_rate: null, journal_entry_date: null })
  const [errors, setErrors] = useState({})

  useEffect(()=>{
    if (openModal) {
      setForm({ billable_exchange_rate: null, journal_entry_date: null })
      setErrors({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[openModal])

  useEffect(() => {
    setForm(prev => ({
      ...prev,
      item_id: [selectedItem?.item_id]
    }))
  }, [selectedItem])

  const onClose = () =>{
    setOpenModal(false)
    setForm({ billable_exchange_rate: null, journal_entry_date: null })
    setErrors({})
  }

  const onSubmit = async () =>{
    let newErrors = { ...errors }
    Object.entries(form).forEach(entry => {
      const [key, value] = entry
      if (!value) newErrors[key] = translate('ra.validation.required')
    })

    setErrors(newErrors)
    if (Object.values(newErrors).some(elem => elem)) {
      return
    }

    setLoadingJournalEntry(true)
    await billingServices.generateJournalEntryItems(form).then(() => {
      onClose()
      notify('ra.notification.provision_generated_success', { type: 'success' })
      onComplete?.()
    }).catch((e)=>{
      notify('ra.notification.provision_generated_error', { type: 'error' })
    }).finally(()=>{
      setLoadingJournalEntry(false)
    })
  }

  const handleChangeForm = (field, value) => {
    setForm((current) => ({
      ...current,
      [field]: value,
    }))
  }

  return (
    <Dialog open={openModal} onClose={onClose} maxWidth={'xs'}>
      <DialogTitle>{`${translate('ra.action.generate')} ${translate('ra.field.provision').toLowerCase()}`}</DialogTitle>

      <DialogContent>
        <Grid container>
          <EditInputsWrap label={translate('ra.field.base')} md={12} lg={12} required>
            <TextField
              value={form?.billable_exchange_rate}
              onChange={(e) => handleChangeForm('billable_exchange_rate', e.target.value ? parseFloat(e.target.value) : null)}
              size='small'
              type='number'
              sx={{ width: { xs: '100%', sm: '100%' } }}
              error={errors.billable_exchange_rate}
            />
            {errors.billable_exchange_rate && (
              <FormHelperText error>{errors.billable_exchange_rate}</FormHelperText>
            )}
          </EditInputsWrap>
          <EditInputsWrap label={translate(`ra.field.journal_entry_date`)} md={12} lg={12} required>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
              <DatePicker
                value={form.journal_entry_date || null}
                label={false}
                onChange={(date) => {
                  if (!date || !date.isValid()) return
                  const onlydate = date.format('YYYY-MM-DD')
                  handleChangeForm('journal_entry_date', onlydate)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant='outlined'
                    size='small'
                    error={errors.journal_entry_date}
                  />
                )}
              />
              {errors.journal_entry_date && (
                <FormHelperText error>{errors.journal_entry_date}</FormHelperText>
              )}
            </LocalizationProvider>
          </EditInputsWrap>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          variant='outlined'
          color='error'
          onClick={onClose}
          disabled={loadingJournalEntry}
        >
          {translate('ra.action.cancel')}
        </Button>
        <LoadingButton
          variant='contained'
          onClick={onSubmit}
          loading={loadingJournalEntry}
        >
          {translate('ra.action.to_confirm')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
